import React, {
  createContext,
  useState,
  Dispatch,
  SetStateAction
} from "react";

interface AlertFilters {
  severityFilter: number[];
  siteFilter: number | null;
  machineFilter: number | null;
  startDateFilter: string | null;
  endDateFilter: string | null;
}

interface AlertFiltersContextType {
  filters: AlertFilters;
  setFilters: Dispatch<SetStateAction<AlertFilters>>;
}

interface AlertFiltersProviderProps {
  children?: React.ReactNode;
}

export const AlertFiltersContext = createContext<AlertFiltersContextType | null>(
  null
);
AlertFiltersContext.displayName = "AlertFiltersContext";

export const AlertsProvider = ({
  children
}: AlertFiltersProviderProps): JSX.Element => {
  const [filters, setFilters] = useState<AlertFilters>({
    severityFilter: [],
    siteFilter: null,
    machineFilter: null,
    startDateFilter: null,
    endDateFilter: null
  });

  return (
    <AlertFiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </AlertFiltersContext.Provider>
  );
};
